import AlertsTableController from './list.controller';

const DashboardAlertsListComponent = {
  template: require('./list.html'),
  bindings: {
    equipmentId: '<',
    predicate: '<',
    alerts: '<',
    search: '<',
    loading: '<',
    updateAlert: '&',
    updatePredicate: '&',
    changeFirstLoad: '&',
    addAlertsInteraction: '<',
  },
  controllerAs: 'vm',
  controller: AlertsTableController,
};

export default DashboardAlertsListComponent;
